export default __webpack_public_path__ + "static/media/closeIcon.2da54505.svg";